export const siteConfig = {
  name: "韩漫屋",
  tagline: "发现最精彩的韩国漫画",
  description: "韩漫屋 - 韩国漫画在线免费阅读平台，提供好看的韩国漫画大全。下拉式阅读体验，随时随地享受精彩韩漫故事，追更热门连载作品。",
  url: "http://jwlauto.cn/",
  keywords: "韩漫,韩国漫画,韩漫在线,韩国漫画大全,下拉式阅读,免费韩漫,韩国漫画网站",
  email: "hello@jwlauto.cn",
  social: {
    wechat: "韩漫屋",
    updates: "http://jwlauto.cn/",
    popular: "http://jwlauto.cn/",
  },
};

export const categories = [
  {
    slug: "romance",
    name: "恋爱甜漫",
    description: "甜蜜浪漫的爱情故事，心动瞬间令人沉醉",
    icon: "ri-heart-line",
    count: 128,
  },
  {
    slug: "fantasy",
    name: "奇幻冒险",
    description: "穿越异世界，开启史诗级冒险旅程",
    icon: "ri-magic-line",
    count: 96,
  },
  {
    slug: "action",
    name: "热血动作",
    description: "拳拳到肉的战斗场景，燃爆你的肾上腺素",
    icon: "ri-fire-line",
    count: 84,
  },
  {
    slug: "thriller",
    name: "悬疑惊悚",
    description: "扣人心弦的悬疑剧情，每一个反转都出人意料",
    icon: "ri-ghost-line",
    count: 62,
  },
  {
    slug: "drama",
    name: "都市剧情",
    description: "现代都市生活百态，真实细腻的情感刻画",
    icon: "ri-building-line",
    count: 75,
  },
  {
    slug: "comedy",
    name: "爆笑喜剧",
    description: "轻松幽默的日常故事，笑到停不下来",
    icon: "ri-emotion-laugh-line",
    count: 53,
  },
  {
    slug: "historical",
    name: "古风历史",
    description: "穿越古今的历史传奇，宫廷权谋引人入胜",
    icon: "ri-book-open-line",
    count: 41,
  },
  {
    slug: "bl",
    name: "BL专区",
    description: "唯美动人的少年之恋，细腻情感触动心弦",
    icon: "ri-star-line",
    count: 89,
  },
];

export const featuredComics = [
  {
    id: 1,
    title: "女神降临",
    author: "猫咪",
    category: "恋爱甜漫",
    categorySlug: "romance",
    status: "连载中",
    rating: 9.5,
    views: "2,380万",
    description: "长相平凡的女主角通过化妆技巧华丽变身，在校园中展开了一段充满戏剧性的青春恋爱故事。精致的画风和细腻的情感描写让这部作品成为韩漫中的经典之作。",
    chapters: 186,
    coverSeq: "featured-01",
    coverQuery: "Beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20stunning%20young%20woman%20with%20long%20dark%20hair%20and%20elegant%20makeup%2C%20soft%20pastel%20background%20with%20cherry%20blossoms%20and%20sparkles%2C%20romantic%20atmosphere%2C%20clean%20lineart%2C%20webtoon%20art%20style%2C%20gentle%20lighting%2C%20simple%20gradient%20backdrop%20in%20warm%20pink%20tones%2C%20editorial%20quality%20portrait%20composition",
  },
  {
    id: 2,
    title: "我独自升级",
    author: "Chugong / DUBU",
    category: "热血动作",
    categorySlug: "action",
    status: "已完结",
    rating: 9.8,
    views: "8,920万",
    description: "世界出现连接异次元的「门」，觉醒者们进入地下城狩猎怪物。最弱E级猎人成振宇在濒死之际获得了「系统」的力量，成为唯一可以升级的猎人，从此踏上成为最强觉醒者的道路。",
    chapters: 179,
    coverSeq: "featured-02",
    coverQuery: "Korean%20manhwa%20art%20style%20illustration%20of%20a%20powerful%20male%20warrior%20with%20dark%20hair%20and%20glowing%20purple%20eyes%2C%20holding%20a%20dagger%20in%20dynamic%20pose%2C%20dark%20atmospheric%20background%20with%20magical%20energy%20wisps%2C%20action%20webtoon%20aesthetic%2C%20dramatic%20lighting%20from%20above%2C%20clean%20simple%20backdrop%20with%20deep%20shadows%2C%20cinematic%20composition",
  },
  {
    id: 3,
    title: "公爵的契约未婚妻",
    author: "Milcha / Whale",
    category: "奇幻冒险",
    categorySlug: "fantasy",
    status: "连载中",
    rating: 9.3,
    views: "4,150万",
    description: "穿越到小说世界成为配角的女主角，为了改变悲惨的命运，主动与北方的冷血公爵签订契约婚约。然而事情的发展远超预期，一场浪漫与阴谋交织的奇幻故事就此展开。",
    chapters: 142,
    coverSeq: "featured-03",
    coverQuery: "Elegant%20Korean%20manhwa%20art%20style%20illustration%20of%20a%20beautiful%20noblewoman%20in%20a%20lavish%20Victorian%20gown%20with%20blonde%20hair%20and%20blue%20eyes%2C%20standing%20in%20a%20grand%20palace%20ballroom%2C%20fantasy%20romance%20webtoon%20aesthetic%2C%20soft%20warm%20candlelight%20glow%2C%20elegant%20composition%20with%20clean%20simple%20background%20in%20golden%20and%20cream%20tones",
  },
  {
    id: 4,
    title: "看脸时代",
    author: "朴泰俊",
    category: "都市剧情",
    categorySlug: "drama",
    status: "连载中",
    rating: 9.4,
    views: "6,780万",
    description: "因外貌被欺凌的胖男孩，一觉醒来拥有了完美的身材和颜值，白天是校园里的完美男神，晚上则变回原来的自己。作品深刻探讨了外貌歧视、校园暴力等社会议题。",
    chapters: 210,
    coverSeq: "featured-04",
    coverQuery: "Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20young%20man%20with%20stylish%20hair%20and%20confident%20expression%2C%20wearing%20modern%20streetwear%20fashion%2C%20urban%20cityscape%20background%20at%20sunset%2C%20drama%20webtoon%20aesthetic%2C%20warm%20golden%20hour%20lighting%2C%20clean%20composition%20with%20soft%20bokeh%20effect%20background",
  },
];

export const latestComics = [
  {
    id: 5,
    title: "剑尊归来",
    author: "Redice Studio",
    category: "热血动作",
    status: "连载中",
    latestChapter: "第92话",
    rating: 9.6,
    coverSeq: "latest-01",
    coverQuery: "Korean%20manhwa%20art%20style%20illustration%20of%20a%20swordsman%20in%20traditional%20martial%20arts%20robe%20with%20flowing%20long%20hair%2C%20holding%20a%20gleaming%20sword%2C%20dramatic%20dynamic%20action%20pose%2C%20dark%20moody%20background%20with%20ink%20wash%20effect%2C%20wuxia%20webtoon%20aesthetic%2C%20powerful%20lighting%2C%20vertical%20portrait%20composition",
  },
  {
    id: 6,
    title: "某天成为公主",
    author: "Spoon / Plutus",
    category: "奇幻冒险",
    status: "连载中",
    latestChapter: "第115话",
    rating: 9.5,
    coverSeq: "latest-02",
    coverQuery: "Beautiful%20Korean%20manhwa%20illustration%20of%20a%20young%20princess%20with%20long%20pink%20hair%20and%20emerald%20eyes%20wearing%20a%20magnificent%20royal%20dress%2C%20standing%20in%20an%20enchanted%20garden%20with%20magical%20flowers%2C%20fantasy%20romance%20webtoon%20style%2C%20soft%20dreamy%20lighting%2C%20clean%20simple%20pastel%20background%2C%20portrait%20composition",
  },
  {
    id: 7,
    title: "全知读者视角",
    author: "Sing N Song / Sleepy-C",
    category: "奇幻冒险",
    status: "连载中",
    latestChapter: "第203话",
    rating: 9.7,
    coverSeq: "latest-03",
    coverQuery: "Korean%20manhwa%20art%20illustration%20of%20a%20young%20man%20with%20glasses%20and%20dark%20hair%20reading%20a%20glowing%20book%2C%20surrounded%20by%20floating%20text%20and%20constellations%2C%20apocalyptic%20fantasy%20theme%2C%20dark%20atmospheric%20background%20with%20cosmic%20elements%2C%20webtoon%20aesthetic%2C%20dramatic%20lighting%2C%20portrait%20composition",
  },
  {
    id: 8,
    title: "恶役只有死亡结局",
    author: "Gwon Gyeoeul / SUOL",
    category: "奇幻冒险",
    status: "连载中",
    latestChapter: "第138话",
    rating: 9.4,
    coverSeq: "latest-04",
    coverQuery: "Elegant%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20villainess%20with%20dark%20wavy%20hair%20and%20red%20eyes%20in%20a%20luxurious%20black%20gown%2C%20holding%20a%20rose%2C%20gothic%20palace%20interior%20background%2C%20dark%20romance%20webtoon%20aesthetic%2C%20dramatic%20chiaroscuro%20lighting%2C%20clean%20elegant%20composition",
  },
  {
    id: 9,
    title: "重生之超级巨星",
    author: "Ahn Soo Min",
    category: "都市剧情",
    status: "连载中",
    latestChapter: "第76话",
    rating: 9.1,
    coverSeq: "latest-05",
    coverQuery: "Korean%20manhwa%20illustration%20of%20a%20charismatic%20male%20celebrity%20with%20stylish%20blonde%20hair%20wearing%20a%20designer%20suit%2C%20standing%20on%20a%20red%20carpet%20with%20camera%20flashes%2C%20glamorous%20entertainment%20industry%20theme%2C%20webtoon%20style%2C%20bright%20spotlight%20lighting%2C%20clean%20composition%20with%20dark%20luxurious%20background",
  },
  {
    id: 10,
    title: "甜蜜的陷阱",
    author: "Lee Hye",
    category: "恋爱甜漫",
    status: "连载中",
    latestChapter: "第54话",
    rating: 8.9,
    coverSeq: "latest-06",
    coverQuery: "Romantic%20Korean%20manhwa%20art%20style%20illustration%20of%20a%20couple%20gazing%20at%20each%20other%20tenderly%2C%20young%20man%20and%20woman%20with%20soft%20expressions%2C%20coffee%20shop%20setting%20with%20warm%20ambient%20lighting%2C%20sweet%20romance%20webtoon%20aesthetic%2C%20gentle%20pastel%20color%20palette%2C%20clean%20simple%20background%2C%20portrait%20composition",
  },
  {
    id: 11,
    title: "笼中鸟",
    author: "Kim Yoon Ji",
    category: "悬疑惊悚",
    status: "连载中",
    latestChapter: "第48话",
    rating: 9.2,
    coverSeq: "latest-07",
    coverQuery: "Dark%20atmospheric%20Korean%20manhwa%20illustration%20of%20a%20mysterious%20woman%20with%20piercing%20eyes%20looking%20through%20window%20bars%2C%20psychological%20thriller%20theme%2C%20rainy%20night%20atmosphere%20with%20moody%20blue%20shadows%2C%20webtoon%20art%20style%2C%20dramatic%20noir%20lighting%2C%20clean%20composition%20with%20deep%20contrast",
  },
  {
    id: 12,
    title: "惹上首席总裁",
    author: "Park Soo Jung",
    category: "恋爱甜漫",
    status: "已完结",
    latestChapter: "第120话（完结）",
    rating: 9.0,
    coverSeq: "latest-08",
    coverQuery: "Stylish%20Korean%20manhwa%20illustration%20of%20a%20handsome%20CEO%20man%20in%20a%20tailored%20suit%20and%20a%20beautiful%20woman%20in%20office%20attire%2C%20corporate%20romance%20theme%2C%20modern%20skyscraper%20office%20with%20city%20view%20through%20windows%2C%20webtoon%20style%2C%20bright%20natural%20daylight%2C%20clean%20professional%20composition",
  },
  {
    id: 13,
    title: "校园爆笑日记",
    author: "Jung Min Ho",
    category: "爆笑喜剧",
    status: "连载中",
    latestChapter: "第88话",
    rating: 9.1,
    coverSeq: "comic-100",
    coverQuery: "Korean%20manhwa%20style%20comedy%20illustration%20of%20a%20cute%20high%20school%20girl%20with%20exaggerated%20funny%20facial%20expression%2C%20classmates%20laughing%20in%20background%2C%20bright%20colorful%20art%20style%2C%20cheerful%20pastel%20yellow%20and%20mint%20backdrop%2C%20school%20comedy%20webtoon%20aesthetic%2C%20warm%20sunny%20lighting%2C%20fun%20portrait%20composition",
  },
  {
    id: 14,
    title: "九尾狐传",
    author: "Lee Jung Hyun",
    category: "古风历史",
    status: "连载中",
    latestChapter: "第67话",
    rating: 9.3,
    coverSeq: "comic-101",
    coverQuery: "Korean%20manhwa%20illustration%20of%20a%20mysterious%20male%20protagonist%20in%20traditional%20Korean%20hanbok%2C%20standing%20in%20an%20ancient%20palace%20courtyard%2C%20moonlight%20casting%20soft%20silver%20glow%2C%20historical%20romance%20webtoon%20aesthetic%2C%20elegant%20warm%20beige%20and%20ochre%20backdrop%2C%20classical%20atmosphere%2C%20portrait%20composition",
  },
  {
    id: 15,
    title: "星之彼方",
    author: "Yoon Soo Ah",
    category: "BL专区",
    status: "连载中",
    latestChapter: "第55话",
    rating: 9.2,
    coverSeq: "comic-102",
    coverQuery: "Korean%20BL%20manhwa%20illustration%20of%20two%20handsome%20young%20men%20in%20stylish%20casual%20clothing%20standing%20close%20together%2C%20soft%20romantic%20gaze%2C%20cherry%20blossom%20park%20setting%2C%20gentle%20pastel%20lavender%20and%20mint%20color%20palette%2C%20dreamy%20atmosphere%2C%20clean%20elegant%20composition%2C%20portrait%20orientation",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "漫画迷小李",
    role: "资深读者",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20with%20friendly%20smile%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20style%2C%20high%20quality%20editorial%20portrait&width=80&height=80&seq=avatar-01&orientation=squarish",
    rating: 5,
    title: "韩漫屋是我每天必刷的网站",
    content: "自从发现了韩漫屋，追漫变得超级方便！下拉式阅读体验太舒服了，画质清晰，更新也快。推荐给了身边好多朋友，现在大家都在用。",
  },
  {
    id: 2,
    name: "动漫达人阿杰",
    role: "动漫博主",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20with%20stylish%20glasses%2C%20confident%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20editorial%20portrait&width=80&height=80&seq=avatar-02&orientation=squarish",
    rating: 5,
    title: "漫画质量一流，分类清晰",
    content: "作为动漫博主，我用过很多漫画平台，韩漫屋的分类系统是最好的。恋爱、奇幻、热血各种类型一目了然，找漫画特别高效。而且每部作品的信息都很完整。",
  },
  {
    id: 3,
    name: "追漫少女小美",
    role: "大学生读者",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20warm%20smile%2C%20long%20dark%20hair%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20portrait&width=80&height=80&seq=avatar-03&orientation=squarish",
    rating: 5,
    title: "深夜刷漫的最佳选择",
    content: "每天晚上睡前都要打开韩漫屋看几话更新，下拉式阅读太适合躺床上看了！《公爵的契约未婚妻》追了一年了，每次更新都第一时间来看，画风真的太美了。",
  },
  {
    id: 4,
    name: "漫画收藏家老王",
    role: "漫画编辑",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20mature%20Asian%20man%20with%20gentle%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20editorial%20portrait&width=80&height=80&seq=avatar-04&orientation=squarish",
    rating: 5,
    title: "专业度和审美品味都在线",
    content: "从业十年了，对漫画平台要求很高。韩漫屋的选品眼光真的很不错，推荐的每部作品都是精品。《我独自升级》这种级别的神作也能在这里第一时间看到更新。",
  },
  {
    id: 5,
    name: "二次元小樱",
    role: "Cosplayer",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20playful%20expression%2C%20colorful%20hair%20accessories%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20editorial%20portrait&width=80&height=80&seq=avatar-05&orientation=squarish",
    rating: 4,
    title: "画风好的漫画都在这里",
    content: "我是因为喜欢韩漫画风才开始cosplay的，韩漫屋上的作品画风都超精美！《女神降临》的女主角就是我cos的第一个角色，网站上的评价帮助我选到了最还原的作品。",
  },
  {
    id: 6,
    name: "通勤阅读者大刘",
    role: "上班族读者",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20in%20business%20casual%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20editorial%20portrait&width=80&height=80&seq=avatar-06&orientation=squarish",
    rating: 5,
    title: "通勤路上最佳伴侣",
    content: "上下班地铁上刷韩漫已经成为习惯了，下拉式阅读单手操作很方便。追了《全知读者视角》快一年了，剧情太精彩了，每天最期待的就是更新提醒。",
  },
];

export const articles = [
  {
    id: 1,
    slug: "solo-leveling-review",
    title: "《我独自升级》完结评测：一部重新定义韩漫天花板的神作",
    excerpt: "从E级到最强，成振宇的升级之路不仅震撼了漫画界，更在全球范围内掀起了一场韩漫热潮。本文深度解析这部现象级作品的成功密码。",
    category: "热血动作",
    coverSeq: "article-01",
    coverQuery: "Epic%20Korean%20manhwa%20style%20illustration%20in%20landscape%20format%20of%20a%20powerful%20shadow%20army%20rising%20behind%20a%20lone%20warrior%20silhouette%2C%20dramatic%20contrast%20between%20black%20shadows%20and%20purple%20energy%2C%20dark%20atmospheric%20backdrop%2C%20cinematic%20wide%20composition%2C%20webtoon%20aesthetic",
    author: "韩漫屋编辑部",
    date: "2024-06-15",
    readTime: "8分钟",
    views: "12,560",
    content: "《我独自升级》作为近年来最具影响力的韩国漫画之一，以其独特的世界观设定、精湛的画工和紧凑的剧情节奏，在全球范围内收获了大量忠实读者。作品讲述了最弱猎人成振宇在濒死之际获得「系统」力量后，从E级一步步成长为最强觉醒者的故事。这部作品最大的魅力在于「成长」这一永恒主题的极致呈现。读者跟随主角的脚步，见证他从弱小到强大、从被保护到保护他人的完整蜕变，这种成长叙事带来的满足感是其他作品难以比拟的。DUBU老师的画工更是令人叹为观止，尤其在后期的战斗场景中，每一个分镜都充满了电影级别的视觉冲击力。",
    faq: [
      { question: "《我独自升级》一共多少话？", answer: "《我独自升级》漫画版共179话（含外传），已全部完结。故事完整度高，结局获得读者广泛好评。" },
      { question: "《我独自升级》有动画吗？", answer: "有的！《我独自升级》动画版已于2024年1月首播，由A-1 Pictures制作，制作精良，还原度极高。目前第一季已完结，第二季正在制作中。" },
      { question: "《我独自升级》哪里可以免费阅读？", answer: "您可以在韩漫屋上免费在线观看《我独自升级》的全部章节，支持下拉式阅读，画质高清，体验流畅。" },
    ],
  },
  {
    id: 2,
    slug: "romance-manhwa-recommend",
    title: "2024年必看的10部韩国恋爱漫画推荐",
    excerpt: "从校园纯爱到宫廷虐恋，我们为你精心挑选了10部2024年最值得追的韩国恋爱漫画，每一部都能让你心动不已。",
    category: "恋爱甜漫",
    coverSeq: "article-02",
    coverQuery: "Romantic%20Korean%20manhwa%20style%20illustration%20in%20landscape%20format%20of%20multiple%20couples%20in%20different%20settings%20like%20cherry%20blossom%20path%2C%20coffee%20shop%2C%20and%20starry%20night%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20webtoon%20aesthetic",
    author: "韩漫屋编辑部",
    date: "2024-05-20",
    readTime: "12分钟",
    views: "18,230",
    content: "韩国恋爱漫画以其细腻的情感描写和精美的画风征服了全球读者的心。2024年涌现出了大量优秀的恋爱漫画作品，我们从中精选了10部不容错过的佳作。《女神降临》作为经典中的经典，用化妆变身的设定探讨了外表与内在的永恒话题；《公爵的契约未婚妻》则将穿越题材与宫廷恋爱完美结合，创造了令人着迷的奇幻世界；新作《甜蜜的陷阱》以美食为媒介，讲述了一段温暖治愈的都市恋情。每部作品都有其独特的魅力，无论你是恋爱漫画的老粉还是新入坑的读者，这份推荐清单都能帮你找到心仪的作品。",
    faq: [
      { question: "韩国恋爱漫画和日本少女漫画有什么区别？", answer: "韩国恋爱漫画（韩漫）通常采用全彩绘制和下拉式阅读格式，画风更加精致细腻，色彩丰富。在剧情上，韩漫往往更加注重现实感和人物心理描写，角色性格也更加多元化和立体。而日本少女漫画以黑白为主，分镜方式更加传统。" },
      { question: "新手入门推荐哪部韩漫？", answer: "对于初次接触韩国恋爱漫画的读者，推荐从《女神降临》开始。这部作品画风精美，故事节奏明快，涉及校园、友情、爱情、自我认同等多个主题，非常适合入门。" },
    ],
  },
  {
    id: 3,
    slug: "manhwa-art-style-guide",
    title: "韩国漫画画风演变史：从传统到数字时代的视觉革命",
    excerpt: "韩漫画风经历了从模仿日漫到形成独特风格的过程，如今已成为全球漫画界不可忽视的视觉力量。",
    category: "行业观察",
    coverSeq: "article-03",
    coverQuery: "Artistic%20Korean%20manhwa%20style%20illustration%20in%20landscape%20format%20showing%20the%20evolution%20of%20art%20styles%20from%20traditional%20ink%20drawing%20to%20modern%20digital%20webtoon%2C%20split%20composition%20with%20left%20side%20classic%20style%20and%20right%20side%20vibrant%20digital%20colors%2C%20clean%20aesthetic",
    author: "韩漫屋编辑部",
    date: "2024-04-10",
    readTime: "15分钟",
    views: "9,870",
    content: "韩国漫画的画风演变是一段精彩的视觉历史。从20世纪90年代受日本漫画影响较大的时期，到21世纪初逐渐形成自己的风格特色，再到如今数字创作时代的全面爆发，韩漫在视觉表现上走过了一条独特的发展道路。早期的韩国漫画家大多使用传统手绘方式，风格上可以明显看到日本漫画的影响。但随着数字绘画工具的普及，韩国漫画家开始探索属于自己的视觉语言。全彩绘制成为韩漫的标志性特征，丰富的色彩运用和精致的背景描绘让韩漫在视觉上具有极强的辨识度。",
    faq: [
      { question: "为什么韩漫都是彩色的？", answer: "韩漫以数字创作为主，webtoon格式天然适合全彩呈现。全彩色不仅提升了视觉体验，也更好地适应了智能手机屏幕的阅读场景。这与日本漫画以黑白印刷为主的传统形成了鲜明对比。" },
      { question: "韩漫的画风有哪些主要流派？", answer: "韩漫画风主要可以分为：写实精致派（如《我独自升级》）、唯美浪漫派（如《女神降临》）、简约清新派（如一些日常喜剧作品）、以及独特的半写实风格。不同题材的作品会选择最适合的画风来呈现。" },
    ],
  },
];

export const aboutData = {
  brandStory: "韩漫屋创立于2020年，是国内最早专注于韩国漫画资讯与推荐的平台之一。我们致力于为中文读者提供最优质的韩国漫画阅读体验，让每一位读者都能轻松发现并享受精彩韩漫。团队核心成员均拥有多年漫画行业经验，对韩国漫画市场有着深刻的理解和敏锐的洞察力。",
  mission: "我们的使命是搭建中韩漫画文化交流的桥梁，让更多中文读者能够接触到优质的韩国漫画作品，同时也为韩国漫画家提供更广阔的展示平台。",
  stats: [
    { value: "2020", label: "创立年份" },
    { value: "500+", label: "收录作品" },
    { value: "80万+", label: "月活读者" },
    { value: "98%", label: "读者好评率" },
  ],
  partners: [
    { name: "Kakao Page", role: "内容合作伙伴" },
    { name: "Naver Webtoon", role: "战略合作伙伴" },
    { name: "Ridibooks", role: "技术合作伙伴" },
    { name: "Lezhin Comics", role: "内容合作伙伴" },
  ],
};
